import { render, staticRenderFns } from "./BulkCalendarSaveForm.vue?vue&type=template&id=f70e7a4a&scoped=true&"
import script from "./BulkCalendarSaveForm.vue?vue&type=script&lang=js&"
export * from "./BulkCalendarSaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70e7a4a",
  null
  
)

export default component.exports